import { Box, Switch, Tooltip } from '@mui/material';
import React from 'react';

interface CellOfferActiveToggleProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children?: React.ReactNode;
}

const CellOfferActiveToggle = ({ params, onClick }: CellOfferActiveToggleProps) => {
  const isActive = Boolean(params?.row?.is_active);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onClick(params, 'toggle');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
      <Tooltip title={isActive ? 'Active' : 'Inactive'}>
        <Switch
          size="small"
          checked={isActive}
          onChange={handleChange}
          color="primary"
          inputProps={{ 'aria-label': isActive ? 'Active' : 'Inactive' }}
        />
      </Tooltip>
    </Box>
  );
};

export default CellOfferActiveToggle;
